'use client';

import { usePathname } from 'next/navigation';
import { Toaster } from '@/components/ui/sonner';
import { rootToasterHidden } from './root-toaster-rules';

/**
 * The app-wide toaster, everywhere but the staff app. Two sonner toasters
 * with no id both show every toast, and the staff layout mounts its own
 * (top centre, inside the event theme so a success toast wears the event's
 * colour), so on /staff this one stands aside and each toast shows once.
 */
export function RootToaster() {
  const pathname = usePathname();
  if (rootToasterHidden(pathname)) return null;
  return <Toaster richColors position="bottom-right" />;
}
